import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"
import { initSmoothScroll, resetSmoothScroll } from "./src/utils/smoothScroll"

export const onClientEntry = () => {
  initSmoothScroll()
}

export const onPreRouteUpdate = ({ prevLocation }) => {
  // サイト内の移動でページが替わるときは、トップの登場アニメーションを出さない（1_top/style.module.css）。
  // 最初に開いたときは prevLocation が無いので付かない
  if (prevLocation) document.documentElement.classList.add("is-routed")
}

export const onRouteUpdate = () => {
  // Gatsby のスクロール復元が終わってから内部位置を同期する
  requestAnimationFrame(resetSmoothScroll)
}